import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	fastshiftTableFilterContextClearFilters: {
		id: 'fastshift.table.filter-context.clear-filters',
		defaultMessage: 'Clear filters',
		description: 'Text for clear all filters button',
	},
});
